// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import AlertCircleFill from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleFill";
import AlertCircleLine from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleLine";
import AlertTriangleFill from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import AlertTriangleLine from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleLine";
import AmericanExpress from "@store/Library/Components/Toolkit/Icons/AmericanExpress";
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ArrowDownward from "@store/Library/Components/Toolkit/Icons/ArrowDownward";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import ArrowiOSBackward from "@store/Library/Components/Toolkit/Icons/ArrowiOSBackward";
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import ArrowiOSForward from "@store/Library/Components/Toolkit/Icons/ArrowiOSForward";
import ArrowiOSUpward from "@store/Library/Components/Toolkit/Icons/ArrowiOSUpward";
import ArrowUpward from "@store/Library/Components/Toolkit/Icons/ArrowUpward";
import AwardFill from "@store/Library/Components/Toolkit/Icons/Award/AwardFill";
import AwardLine from "@store/Library/Components/Toolkit/Icons/Award/AwardLine";
import BackspaceFill from "@store/Library/Components/Toolkit/Icons/Backspace/BackspaceFill";
import BackspaceLine from "@store/Library/Components/Toolkit/Icons/Backspace/BackspaceLine";
import BatteryFill from "@store/Library/Components/Toolkit/Icons/Battery/BatteryFill";
import BatteryLine from "@store/Library/Components/Toolkit/Icons/Battery/BatteryLine";
import BellFill from "@store/Library/Components/Toolkit/Icons/Bell/BellFill";
import BellLine from "@store/Library/Components/Toolkit/Icons/Bell/BellLine";
import BellOffFill from "@store/Library/Components/Toolkit/Icons/BellOff/BellOffFill";
import BellOffLine from "@store/Library/Components/Toolkit/Icons/BellOff/BellOffLine";
import BookFill from "@store/Library/Components/Toolkit/Icons/Book/BookFill";
import BookLine from "@store/Library/Components/Toolkit/Icons/Book/BookLine";
import BookmarkFill from "@store/Library/Components/Toolkit/Icons/Bookmark/BookmarkFill";
import BookmarkLine from "@store/Library/Components/Toolkit/Icons/Bookmark/BookmarkLine";
import BoxCheckmarkFill from "@store/Library/Components/Toolkit/Icons/BoxCheckmark/BoxCheckmarkFill";
import BoxReturnFill from "@store/Library/Components/Toolkit/Icons/BoxReturn/BoxReturnFill";
import BoxReturnLine from "@store/Library/Components/Toolkit/Icons/BoxReturn/BoxReturnLine";
import Facebook from "@store/Library/Components/Toolkit/Icons/Brand/Facebook";
import Instagram from "@store/Library/Components/Toolkit/Icons/Brand/Instagram";
import Linkedin from "@store/Library/Components/Toolkit/Icons/Brand/Linkedin";
import Pinterest from "@store/Library/Components/Toolkit/Icons/Brand/Pinterest";
import Twitter from "@store/Library/Components/Toolkit/Icons/Brand/Twitter";
import Youtube from "@store/Library/Components/Toolkit/Icons/Brand/Youtube";
import CalendarFill from "@store/Library/Components/Toolkit/Icons/Calendar/CalendarFill";
import CalendarLine from "@store/Library/Components/Toolkit/Icons/Calendar/CalendarLine";
import CarFill from "@store/Library/Components/Toolkit/Icons/Car/CarFill";
import CarLine from "@store/Library/Components/Toolkit/Icons/Car/CarLine";
import CartCheckmarkFill from "@store/Library/Components/Toolkit/Icons/CartCheckmark/CartCheckmarkFill";
import CartCheckmarkLine from "@store/Library/Components/Toolkit/Icons/CartCheckmark/CartCheckmarkLine";
import CartPlusFill from "@store/Library/Components/Toolkit/Icons/CartPlus/CartPlusFill";
import CartPlusLine from "@store/Library/Components/Toolkit/Icons/CartPlus/CartPlusLine";
import CheckboxChecked from "@store/Library/Components/Toolkit/Icons/Checkbox/CheckboxChecked";
import CheckboxIndeterminate from "@store/Library/Components/Toolkit/Icons/Checkbox/CheckboxIndeterminate";
import Checkmark from "@store/Library/Components/Toolkit/Icons/Checkmark";
import CheckmarkCircle from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle";
import CheckmarkCircle2Fill from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle2/CheckmarkCircle2Fill";
import CheckmarkCircle2Line from "@store/Library/Components/Toolkit/Icons/CheckmarkCircle2/CheckmarkCircle2Line";
import CheckmarkSquare2Fill from "@store/Library/Components/Toolkit/Icons/CheckmarkSquare2/CheckmarkSquare2Fill";
import CheckmarkSquare2Line from "@store/Library/Components/Toolkit/Icons/CheckmarkSquare2/CheckmarkSquare2Line";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import ChevronsUpDown from "@store/Library/Components/Toolkit/Icons/ChevronsUpDown";
import ChevronUp from "@store/Library/Components/Toolkit/Icons/ChevronUp";
import ClockFill from "@store/Library/Components/Toolkit/Icons/Clock/ClockFill";
import ClockLine from "@store/Library/Components/Toolkit/Icons/Clock/ClockLine";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import CloseCircleFill from "@store/Library/Components/Toolkit/Icons/CloseCircle/CloseCircleFill";
import CloseCircleLine from "@store/Library/Components/Toolkit/Icons/CloseCircle/CloseCircleLine";
import CompareFill from "@store/Library/Components/Toolkit/Icons/Compare/CompareFill";
import CopyFill from "@store/Library/Components/Toolkit/Icons/Copy/CopyFill";
import CopyLine from "@store/Library/Components/Toolkit/Icons/Copy/CopyLine";
import CubeFill from "@store/Library/Components/Toolkit/Icons/Cube/CubeFill";
import CubeLine from "@store/Library/Components/Toolkit/Icons/Cube/CubeLine";
import Discover from "@store/Library/Components/Toolkit/Icons/Discover";
import DoubleChevronDown from "@store/Library/Components/Toolkit/Icons/DoubleChevronDown";
import DoubleChevronLeft from "@store/Library/Components/Toolkit/Icons/DoubleChevronLeft";
import DoubleChevronRight from "@store/Library/Components/Toolkit/Icons/DoubleChevronRight";
import DoubleChevronUp from "@store/Library/Components/Toolkit/Icons/DoubleChevronUp";
import Download from "@store/Library/Components/Toolkit/Icons/Download";
import EditFill from "@store/Library/Components/Toolkit/Icons/Edit/EditFill";
import EditLine from "@store/Library/Components/Toolkit/Icons/Edit/EditLine";
import EmailFill from "@store/Library/Components/Toolkit/Icons/Email/EmailFill";
import EmailLine from "@store/Library/Components/Toolkit/Icons/Email/EmailLine";
import Export from "@store/Library/Components/Toolkit/Icons/Export";
import ExternalLink from "@store/Library/Components/Toolkit/Icons/ExternalLink";
import EyeFill from "@store/Library/Components/Toolkit/Icons/Eye/EyeFill";
import EyeLine from "@store/Library/Components/Toolkit/Icons/Eye/EyeLine";
import EyeOffFill from "@store/Library/Components/Toolkit/Icons/EyeOff/EyeOffFill";
import EyeOffLine from "@store/Library/Components/Toolkit/Icons/EyeOff/EyeOffLine";
import GlobeFill from "@store/Library/Components/Toolkit/Icons/Globe/GlobeFill";
import GlobeLine from "@store/Library/Components/Toolkit/Icons/Globe/GlobeLine";
import GridFill from "@store/Library/Components/Toolkit/Icons/Grid/GridFill";
import GridLine from "@store/Library/Components/Toolkit/Icons/Grid/GridLine";
import GridView from "@store/Library/Components/Toolkit/Icons/GridView";
import HeadphonesFill from "@store/Library/Components/Toolkit/Icons/Headphones/HeadphonesFill";
import HeadphonesLine from "@store/Library/Components/Toolkit/Icons/Headphones/HeadphonesLine";
import HeartFill from "@store/Library/Components/Toolkit/Icons/Heart/HeartFill";
import HeartLine from "@store/Library/Components/Toolkit/Icons/Heart/HeartLine";
import Import from "@store/Library/Components/Toolkit/Icons/Import";
import InfoFill from "@store/Library/Components/Toolkit/Icons/Info/InfoFill";
import InfoLine from "@store/Library/Components/Toolkit/Icons/Info/InfoLine";
import List from "@store/Library/Components/Toolkit/Icons/List";
import ListView from "@store/Library/Components/Toolkit/Icons/ListView";
import LogIn from "@store/Library/Components/Toolkit/Icons/LogIn";
import LogOut from "@store/Library/Components/Toolkit/Icons/LogOut";
import Mastercard from "@store/Library/Components/Toolkit/Icons/Mastercard";
import Menu from "@store/Library/Components/Toolkit/Icons/Menu";
import Minus from "@store/Library/Components/Toolkit/Icons/Minus";
import MinusCircleFill from "@store/Library/Components/Toolkit/Icons/MinusCircle/MinusCircleFill";
import MinusCircleLine from "@store/Library/Components/Toolkit/Icons/MinusCircle/MinusCircleLine";
import Move from "@store/Library/Components/Toolkit/Icons/Move";
import NavigationFill from "@store/Library/Components/Toolkit/Icons/Navigation/NavigationFill";
import NavigationLine from "@store/Library/Components/Toolkit/Icons/Navigation/NavigationLine";
import Navigation2Fill from "@store/Library/Components/Toolkit/Icons/Navigation2/Navigation2Fill";
import Navigation2Line from "@store/Library/Components/Toolkit/Icons/Navigation2/Navigation2Line";
import Options2Fill from "@store/Library/Components/Toolkit/Icons/Options2/Options2Fill";
import Options2Line from "@store/Library/Components/Toolkit/Icons/Options2/Options2Line";
import Pause from "@store/Library/Components/Toolkit/Icons/Pause";
import PersonFill from "@store/Library/Components/Toolkit/Icons/Person/PersonFill";
import PersonLine from "@store/Library/Components/Toolkit/Icons/Person/PersonLine";
import PersonAddFill from "@store/Library/Components/Toolkit/Icons/PersonAdd/PersonAddFill";
import PersonAddLine from "@store/Library/Components/Toolkit/Icons/PersonAdd/PersonAddLine";
import PhoneFill from "@store/Library/Components/Toolkit/Icons/Phone/PhoneFill";
import PhoneLine from "@store/Library/Components/Toolkit/Icons/Phone/PhoneLine";
import PinFill from "@store/Library/Components/Toolkit/Icons/Pin/PinFill";
import PinFull from "@store/Library/Components/Toolkit/Icons/Pin/PinFull";
import PinLine from "@store/Library/Components/Toolkit/Icons/Pin/PinLine";
import Play from "@store/Library/Components/Toolkit/Icons/Play";
import Plus from "@store/Library/Components/Toolkit/Icons/Plus";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import PlusCircleLine from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleLine";
import PrinterFill from "@store/Library/Components/Toolkit/Icons/Printer/PrinterFill";
import PrinterLine from "@store/Library/Components/Toolkit/Icons/Printer/PrinterLine";
import QuestionMarkCircleFill from "@store/Library/Components/Toolkit/Icons/QuestionMarkCircle/QuestionMarkCircleFill";
import QuestionMarkCircleLine from "@store/Library/Components/Toolkit/Icons/QuestionMarkCircle/QuestionMarkCircleLine";
import QuickOrderFill from "@store/Library/Components/Toolkit/Icons/QuickOrder/QuickOrderFill";
import QuickOrderLine from "@store/Library/Components/Toolkit/Icons/QuickOrder/QuickOrderLine";
import Refresh from "@store/Library/Components/Toolkit/Icons/Refresh";
import ReorderFill from "@store/Library/Components/Toolkit/Icons/Reorder/ReorderFill";
import ReorderLine from "@store/Library/Components/Toolkit/Icons/Reorder/ReorderLine";
import SaveFill from "@store/Library/Components/Toolkit/Icons/Save/SaveFill";
import SaveLine from "@store/Library/Components/Toolkit/Icons/Save/SaveLine";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import SettingsFill from "@store/Library/Components/Toolkit/Icons/Settings/SettingsFill";
import SettingsLine from "@store/Library/Components/Toolkit/Icons/Settings/SettingsLine";
import ShareFill from "@store/Library/Components/Toolkit/Icons/Share/ShareFill";
import ShareLine from "@store/Library/Components/Toolkit/Icons/Share/ShareLine";
import ShoppingBagFill from "@store/Library/Components/Toolkit/Icons/ShoppingBag/ShoppingBagFill";
import ShoppingBagLine from "@store/Library/Components/Toolkit/Icons/ShoppingBag/ShoppingBagLine";
import ShoppingCartFill from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartFill";
import ShoppingCartLine from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartLine";
import Slash from "@store/Library/Components/Toolkit/Icons/Slash";
import StarFill from "@store/Library/Components/Toolkit/Icons/Star/StarFill";
import StarLine from "@store/Library/Components/Toolkit/Icons/Star/StarLine";
import TagLine from "@store/Library/Components/Toolkit/Icons/Tag/TagLine";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import TrashLine from "@store/Library/Components/Toolkit/Icons/Trash/TrashLine";
import Trash2Fill from "@store/Library/Components/Toolkit/Icons/Trash2/Trash2Fill";
import Trash2Line from "@store/Library/Components/Toolkit/Icons/Trash2/Trash2Line";
import UndoFill from "@store/Library/Components/Toolkit/Icons/Undo/UndoFill";
import Upload from "@store/Library/Components/Toolkit/Icons/Upload";
import Visa from "@store/Library/Components/Toolkit/Icons/Visa";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface IconProps extends IconPresentationProps {}

const StyleguideIcon: FC<IconProps> = ({ src, title: baseTitle, ...otherProps }) => (
    <StyledWrapper title={baseTitle}>
        <Icon src={src} {...otherProps} />
    </StyledWrapper>
);

const contentCss = css`
    display: flex;
    flex-flow: row wrap;
    gap: ${pxToRem(16)};
`;

const StyleguideIcons: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Icons" sectionId={sectionId}>
            <StyledWrapper css={contentCss}>
                <StyleguideIcon src={AlertCircleFill} title="AlertCircleFill" />
                <StyleguideIcon src={AlertCircleLine} title="AlertCircleLine" />
                <StyleguideIcon src={AlertTriangleFill} title="AlertTriangleFill" />
                <StyleguideIcon src={AlertTriangleLine} title="AlertTriangleLine" />
                <StyleguideIcon src={AwardFill} title="AwardFill" />
                <StyleguideIcon src={AwardLine} title="AwardLine" />
                <StyleguideIcon src={BackspaceFill} title="BackspaceFill" />
                <StyleguideIcon src={BackspaceLine} title="BackspaceLine" />
                <StyleguideIcon src={BatteryFill} title="BatteryFill" />
                <StyleguideIcon src={BatteryLine} title="BatteryLine" />
                <StyleguideIcon src={BellFill} title="BellFill" />
                <StyleguideIcon src={BellLine} title="BellLine" />
                <StyleguideIcon src={BellOffFill} title="BellOffFill" />
                <StyleguideIcon src={BellOffLine} title="BellOffLine" />
                <StyleguideIcon src={BookFill} title="BookFill" />
                <StyleguideIcon src={BookLine} title="BookLine" />
                <StyleguideIcon src={BookmarkFill} title="BookmarkFill" />
                <StyleguideIcon src={BookmarkLine} title="BookmarkLine" />
                <StyleguideIcon src={BoxCheckmarkFill} title="BoxCheckmarkFill" />
                <StyleguideIcon src={BoxReturnFill} title="BoxReturnFill" />
                <StyleguideIcon src={BoxReturnLine} title="BoxReturnLine" />
                <StyleguideIcon src={Facebook} title="Facebook" />
                <StyleguideIcon src={Instagram} title="Instagram" />
                <StyleguideIcon src={Linkedin} title="Linkedin" />
                <StyleguideIcon src={Pinterest} title="Pinterest" />
                <StyleguideIcon src={Twitter} title="Twitter" />
                <StyleguideIcon src={Youtube} title="Youtube" />
                <StyleguideIcon src={CalendarFill} title="CalendarFill" />
                <StyleguideIcon src={CalendarLine} title="CalendarLine" />
                <StyleguideIcon src={CarFill} title="CarFill" />
                <StyleguideIcon src={CarLine} title="CarLine" />
                <StyleguideIcon src={CartCheckmarkFill} title="CartCheckmarkFill" />
                <StyleguideIcon src={CartCheckmarkLine} title="CartCheckmarkLine" />
                <StyleguideIcon src={CartPlusFill} title="CartPlusFill" />
                <StyleguideIcon src={CartPlusLine} title="CartPlusLine" />
                <StyleguideIcon src={CheckboxChecked} title="CheckboxChecked" />
                <StyleguideIcon src={CheckboxIndeterminate} title="CheckboxIndeterminate" />
                <StyleguideIcon src={CheckmarkCircle2Fill} title="CheckmarkCircle2Fill" />
                <StyleguideIcon src={CheckmarkCircle2Line} title="CheckmarkCircle2Line" />
                <StyleguideIcon src={CheckmarkSquare2Fill} title="CheckmarkSquare2Fill" />
                <StyleguideIcon src={CheckmarkSquare2Line} title="CheckmarkSquare2Line" />
                <StyleguideIcon src={ClockFill} title="ClockFill" />
                <StyleguideIcon src={ClockLine} title="ClockLine" />
                <StyleguideIcon src={CloseCircleFill} title="CloseCircleFill" />
                <StyleguideIcon src={CloseCircleLine} title="CloseCircleLine" />
                <StyleguideIcon src={CompareFill} title="CompareFill" />
                <StyleguideIcon src={CopyFill} title="CopyFill" />
                <StyleguideIcon src={CopyLine} title="CopyLine" />
                <StyleguideIcon src={CubeFill} title="CubeFill" />
                <StyleguideIcon src={CubeLine} title="CubeLine" />
                <StyleguideIcon src={EditFill} title="EditFill" />
                <StyleguideIcon src={EditLine} title="EditLine" />
                <StyleguideIcon src={EmailFill} title="EmailFill" />
                <StyleguideIcon src={EmailLine} title="EmailLine" />
                <StyleguideIcon src={EyeFill} title="EyeFill" />
                <StyleguideIcon src={EyeLine} title="EyeLine" />
                <StyleguideIcon src={EyeOffFill} title="EyeOffFill" />
                <StyleguideIcon src={EyeOffLine} title="EyeOffLine" />
                <StyleguideIcon src={GlobeFill} title="GlobeFill" />
                <StyleguideIcon src={GlobeLine} title="GlobeLine" />
                <StyleguideIcon src={GridFill} title="GridFill" />
                <StyleguideIcon src={GridLine} title="GridLine" />
                <StyleguideIcon src={HeadphonesFill} title="HeadphonesFill" />
                <StyleguideIcon src={HeadphonesLine} title="HeadphonesLine" />
                <StyleguideIcon src={HeartFill} title="HeartFill" />
                <StyleguideIcon src={HeartLine} title="HeartLine" />
                <StyleguideIcon src={InfoFill} title="InfoFill" />
                <StyleguideIcon src={InfoLine} title="InfoLine" />
                <StyleguideIcon src={MinusCircleFill} title="MinusCircleFill" />
                <StyleguideIcon src={MinusCircleLine} title="MinusCircleLine" />
                <StyleguideIcon src={NavigationFill} title="NavigationFill" />
                <StyleguideIcon src={NavigationLine} title="NavigationLine" />
                <StyleguideIcon src={Navigation2Fill} title="Navigation2Fill" />
                <StyleguideIcon src={Navigation2Line} title="Navigation2Line" />
                <StyleguideIcon src={Options2Fill} title="Options2Fill" />
                <StyleguideIcon src={Options2Line} title="Options2Line" />
                <StyleguideIcon src={PersonFill} title="PersonFill" />
                <StyleguideIcon src={PersonLine} title="PersonLine" />
                <StyleguideIcon src={PersonAddFill} title="PersonAddFill" />
                <StyleguideIcon src={PersonAddLine} title="PersonAddLine" />
                <StyleguideIcon src={PhoneFill} title="PhoneFill" />
                <StyleguideIcon src={PhoneLine} title="PhoneLine" />
                <StyleguideIcon src={PinFill} title="PinFill" />
                <StyleguideIcon src={PinFull} title="PinFull" />
                <StyleguideIcon src={PinLine} title="PinLine" />
                <StyleguideIcon src={PlusCircleFill} title="PlusCircleFill" />
                <StyleguideIcon src={PlusCircleLine} title="PlusCircleLine" />
                <StyleguideIcon src={PrinterFill} title="PrinterFill" />
                <StyleguideIcon src={PrinterLine} title="PrinterLine" />
                <StyleguideIcon src={QuestionMarkCircleFill} title="QuestionMarkCircleFill" />
                <StyleguideIcon src={QuestionMarkCircleLine} title="QuestionMarkCircleLine" />
                <StyleguideIcon src={QuickOrderFill} title="QuickOrderFill" />
                <StyleguideIcon src={QuickOrderLine} title="QuickOrderLine" />
                <StyleguideIcon src={ReorderFill} title="ReorderFill" />
                <StyleguideIcon src={ReorderLine} title="ReorderLine" />
                <StyleguideIcon src={SaveFill} title="SaveFill" />
                <StyleguideIcon src={SaveLine} title="SaveLine" />
                <StyleguideIcon src={SettingsFill} title="SettingsFill" />
                <StyleguideIcon src={SettingsLine} title="SettingsLine" />
                <StyleguideIcon src={ShareFill} title="ShareFill" />
                <StyleguideIcon src={ShareLine} title="ShareLine" />
                <StyleguideIcon src={ShoppingBagFill} title="ShoppingBagFill" />
                <StyleguideIcon src={ShoppingBagLine} title="ShoppingBagLine" />
                <StyleguideIcon src={ShoppingCartFill} title="ShoppingCartFill" />
                <StyleguideIcon src={ShoppingCartLine} title="ShoppingCartLine" />
                <StyleguideIcon src={StarFill} title="StarFill" />
                <StyleguideIcon src={StarLine} title="StarLine" />
                <StyleguideIcon src={TagLine} title="TagLine" />
                <StyleguideIcon src={TrashFill} title="TrashFill" />
                <StyleguideIcon src={TrashLine} title="TrashLine" />
                <StyleguideIcon src={Trash2Fill} title="Trash2Fill" />
                <StyleguideIcon src={Trash2Line} title="Trash2Line" />
                <StyleguideIcon src={UndoFill} title="UndoFill" />
                <StyleguideIcon src={AmericanExpress} title="AmericanExpress" />
                <StyleguideIcon src={ArrowBackward} title="ArrowBackward" />
                <StyleguideIcon src={ArrowDownward} title="ArrowDownward" />
                <StyleguideIcon src={ArrowForward} title="ArrowForward" />
                <StyleguideIcon src={ArrowiOSBackward} title="ArrowiOSBackward" />
                <StyleguideIcon src={ArrowiOSDownward} title="ArrowiOSDownward" />
                <StyleguideIcon src={ArrowiOSForward} title="ArrowiOSForward" />
                <StyleguideIcon src={ArrowiOSUpward} title="ArrowiOSUpward" />
                <StyleguideIcon src={ArrowUpward} title="ArrowUpward" />
                <StyleguideIcon src={Checkmark} title="Checkmark" />
                <StyleguideIcon src={CheckmarkCircle} title="CheckmarkCircle" />
                <StyleguideIcon src={ChevronDown} title="ChevronDown" />
                <StyleguideIcon src={ChevronLeft} title="ChevronLeft" />
                <StyleguideIcon src={ChevronRight} title="ChevronRight" />
                <StyleguideIcon src={ChevronsUpDown} title="ChevronsUpDown" />
                <StyleguideIcon src={ChevronUp} title="ChevronUp" />
                <StyleguideIcon src={Close} title="Close" />
                <StyleguideIcon src={Discover} title="Discover" />
                <StyleguideIcon src={DoubleChevronDown} title="DoubleChevronDown" />
                <StyleguideIcon src={DoubleChevronLeft} title="DoubleChevronLeft" />
                <StyleguideIcon src={DoubleChevronRight} title="DoubleChevronRight" />
                <StyleguideIcon src={DoubleChevronUp} title="DoubleChevronUp" />
                <StyleguideIcon src={Download} title="Download" />
                <StyleguideIcon src={Export} title="Export" />
                <StyleguideIcon src={ExternalLink} title="ExternalLink" />
                <StyleguideIcon src={GridView} title="GridView" />
                <StyleguideIcon src={Import} title="Import" />
                <StyleguideIcon src={List} title="List" />
                <StyleguideIcon src={ListView} title="ListView" />
                <StyleguideIcon src={LogIn} title="LogIn" />
                <StyleguideIcon src={LogOut} title="LogOut" />
                <StyleguideIcon src={Mastercard} title="Mastercard" />
                <StyleguideIcon src={Menu} title="Menu" />
                <StyleguideIcon src={Minus} title="Minus" />
                <StyleguideIcon src={Move} title="Move" />
                <StyleguideIcon src={Pause} title="Pause" />
                <StyleguideIcon src={Play} title="Play" />
                <StyleguideIcon src={Plus} title="Plus" />
                <StyleguideIcon src={Refresh} title="Refresh" />
                <StyleguideIcon src={Search} title="Search" />
                <StyleguideIcon src={Slash} title="Slash" />
                <StyleguideIcon src={Upload} title="Upload" />
                <StyleguideIcon src={Visa} title="Visa" />
            </StyledWrapper>
        </StyleguideSection>
    );
};

export default StyleguideIcons;
